import { render, staticRenderFns } from "./AddonAppTab.vue?vue&type=template&id=a66dde34&scoped=true"
import script from "./AddonAppTab.vue?vue&type=script&lang=js"
export * from "./AddonAppTab.vue?vue&type=script&lang=js"
import style0 from "./AddonAppTab.vue?vue&type=style&index=0&id=a66dde34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66dde34",
  null
  
)

export default component.exports